/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdVehicleStreamVehicleGuidanceActionCardVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  latestLocation: {
    __typename?: 'VehicleLocation'
    heading: number | null
    location: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    } | null
  } | null
}

export type PublishSdsGuidanceDecisionMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  issueId: Types.Scalars['ID']['input']
  decision: Types.SdsGuidanceDecisionInput
}>

export type PublishSdsGuidanceDecisionMutation = {
  __typename?: 'Mutation'
  publishSDSGuidanceDecision: boolean | null
}

export const AdVehicleStreamVehicleGuidanceActionCardVehicleFragmentDoc = gql`
    fragment AdVehicleStreamVehicleGuidanceActionCardVehicle on Vehicle {
  id
  ...RoadBlockageCreationVehicle
}
    `
export const PublishSdsGuidanceDecisionDocument = gql`
    mutation publishSDSGuidanceDecision($vehicleId: ID!, $issueId: ID!, $decision: SDSGuidanceDecisionInput!) {
  publishSDSGuidanceDecision(
    input: {vehicleId: $vehicleId, issueId: $issueId, decision: $decision}
  )
}
    `
export type PublishSdsGuidanceDecisionMutationFn = Apollo.MutationFunction<
  PublishSdsGuidanceDecisionMutation,
  PublishSdsGuidanceDecisionMutationVariables
>

/**
 * __usePublishSdsGuidanceDecisionMutation__
 *
 * To run a mutation, you first call `usePublishSdsGuidanceDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSdsGuidanceDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSdsGuidanceDecisionMutation, { data, loading, error }] = usePublishSdsGuidanceDecisionMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      issueId: // value for 'issueId'
 *      decision: // value for 'decision'
 *   },
 * });
 */
export function usePublishSdsGuidanceDecisionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishSdsGuidanceDecisionMutation,
    PublishSdsGuidanceDecisionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PublishSdsGuidanceDecisionMutation,
    PublishSdsGuidanceDecisionMutationVariables
  >(PublishSdsGuidanceDecisionDocument, options)
}
export type PublishSdsGuidanceDecisionMutationHookResult = ReturnType<
  typeof usePublishSdsGuidanceDecisionMutation
>
export type PublishSdsGuidanceDecisionMutationResult =
  Apollo.MutationResult<PublishSdsGuidanceDecisionMutation>
export type PublishSdsGuidanceDecisionMutationOptions =
  Apollo.BaseMutationOptions<
    PublishSdsGuidanceDecisionMutation,
    PublishSdsGuidanceDecisionMutationVariables
  >
